function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M25.287,5.168c0.053-0.948-1.138-1.348-1.396-1.989c0.177-0.183,0.373-1.325,0.323-1.683 c-0.049-0.346-0.829,0.445-0.967,0.287c-0.157-0.183,0.109-0.971-0.18-1.377c-0.147-0.207-0.483,1.327-0.737,1.442 c-0.183,0.082-0.502-0.351-0.828-0.95c-0.533-0.979-0.239,1.129-0.188,1.531c-1.413,0.216-2.298,1.153-2.696,2.369 c-0.438,1.337-1.661,4.313-3.911,4.454c-2.703,0.17-5.718-2.358-7.14-3.814C6.81,4.665,6.257,2.439,4.931,2.611 C4.332,2.689,3.861,3.535,3.16,3.717c0,0-3.6,0.889-3.115,1.856c0.286,0.569,1.859,1.316,3.06,1.82 C3.158,7.414,3.187,7.474,3.17,7.528c-0.017,0.056-0.072,0.089-0.128,0.08c-1.03-0.183-2.054-0.222-1.03,0.657 C2.265,8.482,3.214,8.94,4.104,9.347c0.053,0.023,0.08,0.084,0.06,0.139C4.145,9.541,4.088,9.573,4.031,9.559 C3.31,9.384,2.655,9.308,2.695,9.623c0.089,0.71,2.828,2.794,2.828,2.794c-0.347,0.426,1.065,1.955,1.29,2.147 c-0.324-0.108-0.673,0.016-0.214,0.431c0.676,0.614,0.826,1.604,1.404,2.178c1.699,1.689,4.248,0.415,5.561,3.267 c0.068,0.148,0.367,0.747,0.624,1.27c0.077,0.156,0.077,0.339,0.001,0.495c-0.077,0.156-0.222,0.269-0.392,0.304l-1.699,0.352 c-0.247,0.051-0.421,0.28-0.397,0.537c0.026,0.274,0.27,0.478,0.545,0.451l1.68-0.157c0.056-0.005,0.11,0.024,0.137,0.074 s0.02,0.111-0.017,0.155l-0.134,0.161c-0.176,0.212-0.147,0.527,0.065,0.704c0.093,0.077,0.206,0.115,0.319,0.115 c0.144,0,0.285-0.062,0.385-0.181l0.707-0.851c0.134-0.161,0.346-0.234,0.551-0.19l2.476,0.532c0.246,0.053,0.498-0.087,0.58-0.331 c0.088-0.262-0.054-0.546-0.316-0.634l-2.234-0.747c-0.203-0.067-0.351-0.246-0.379-0.458c-0.054-0.398-0.124-0.9-0.173-1.284 c-0.033-0.258,0.125-0.502,0.373-0.577c1.134-0.34,1.741-1.725,2.477-2.658c0.337-0.43,0.813-0.722,1.348-0.831 c2.928-0.597,3.921-3.638,4.229-6.854c0.182-1.898-0.71-2.667-1.182-4.08C23.731,5.579,24.381,4.692,25.287,5.168z M22.065,4.111 c-0.218,0-0.393-0.176-0.393-0.394c0-0.22,0.176-0.396,0.393-0.396c0.223,0,0.394,0.176,0.394,0.396 C22.459,3.935,22.287,4.111,22.065,4.111z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgAve = function SvgAve(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.289 25.289",
    style: {
      enableBackground: "new 0 0 25.289 25.289"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAve, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ave.fb45a8d4.svg";
export { ForwardRef as ReactComponent };